import styled from "styled-components";

export const StyledFooter = styled.div(({ theme }) => `
      padding-left: ${theme.uptimeSpace[12]}px;
      padding-right: ${theme.uptimeSpace[12]}px;
      background-color: ${theme.uptimeColors.generalColors.footer.background};
      color: ${theme.uptimeColors.generalColors.footer.textColor ? theme.uptimeColors.generalColors.footer.textColor : `rgba(0, 0, 0, 0.6)`};
      min-height: auto;
      display: flex;
      justify-content: center;
      &::before {
        content: none;
      }
      .uptime-footer-back-to-top {
        display: inline-flex;
        cursor: pointer;
        svg {
          color: ${theme.uptimeColors.generalColors.footer.buttonColor ? theme.uptimeColors.generalColors.footer.buttonColor : theme.uptimeColors.mainTheme.primary};
          margin-top: ${theme.uptimeSpace[1]}px;
          margin-right: ${theme.uptimeSpace[4]}px;
          font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
        }
      }
      .uptime-footer-back-to-top:hover {
        svg {
          color: ${theme.uptimeColors.generalColors.footer.buttonColor ? theme.uptimeColors.generalColors.footer.buttonColor : theme.uptimeColors.mainTheme.primary}
        }
        p {
          text-decoration: underline;
          color: ${theme.uptimeColors.generalColors.footer.buttonColor ? theme.uptimeColors.generalColors.footer.buttonColor : theme.uptimeColors.mainTheme.primary}
        }
      }
      .uptime-footer-container {
        width: 100%;
        border-top: 1px solid rgba(0,0,0,.1);
        padding: 25px 0 ${theme.uptimeSpace[20]}px;

        #lbl-footer-version {
          font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
          font-weight: 400;
          line-height: ${theme.uptimeLineHeights.desktop.lh4}px;
          display: inline;
        }

        .uptime-footer-link {
          ul {
            list-style: none;
            display: flex;
            justify-content: flex-end;
            margin: 0;
            padding: 0;
            a {
              color: ${theme.uptimeColors.generalColors.footer.textColor ? theme.uptimeColors.generalColors.footer.textColor : `rgba(0, 0, 0, 0.6)`};
              font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
              font-weight: 400;
              line-height: ${theme.uptimeLineHeights.desktop.lh4}px;
              text-decoration: underline;
            }
            li:not(:last-child)::after {
              content: '|';
              color: rgba(0, 0, 0, 0.6);
              padding: ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[2]}px;
            }
            a:hover {
              color: ${theme.uptimeColors.mainTheme.primary}
            }
          }
        }
        
        @media screen and (max-width: 767px) {
          .uptime-footer-copyright {
            text-align: center;
          }
          .uptime-footer-link {
            margin-top: ${theme.uptimeSpace[8]}px;
            ul {
              justify-content: center;
            }
          }

          .MuiGrid-item {
            flex-basis: 100%;
            max-width: 100%;
          }
        }

        @media (min-width: 600px) {
          margin-top: ${theme.uptimeDynamicAlignCenter?.footer?.copyright?.marginTop ? theme.uptimeDynamicAlignCenter?.footer?.copyright?.marginTop : '40px'};
        }
        
      }
  `
);
